module.exports = __webpack_public_path__ + "img/burrata_bites_side.daca77f7.jpg";